.component {
  position: relative;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  background-color: var(--fully-white);
}

.table {
  width: 100%;
}

.headerRow, .row {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 24px;
}

.headerRow {
  height: 34px;
  font-size: 12px;
  font-weight: bold;
  color: var(--black);
  background-color: var(--ice-blue-dark);
}

.row {
  position: relative;
  height: 40px;
}

.row:after {
  content: "";
  position: absolute;
  left: 24px;
  right: 24px;
  bottom: 0;
  height: 0;
  opacity: 0.4;
  border-bottom: solid 1px var(--pinkish-grey);
}

.row:hover {
  background-color: var(--ice-blue);
}

.version {
  width: 140px;
  font-size: 14px;
  color: var(--marine);
  font-weight: bold;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.headerRow .version {
  font-size: 12px;
  color: var(--black);
}

.source {
  width: 90px;
}

.sourceBadge {
  display: inline-block;
  padding: 1px 8px;
  font-size: 11px;
  line-height: 16px;
  text-transform: capitalize;
  color: var(--fully-white);
  border-radius: 9px;
}

.auto {
  background-color: var(--brown-grey);
}

.api {
  background-color: var(--tealish);
}

.github {
  background-color: var(--marine);
}

.firstSeen {
  width: 200px;
  font-size: 13px;
  color: var(--brown-grey);
}

.adoption {
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-right: 20px;
}

.adoptionBar {
  flex: 1;
  height: 8px;
  border-radius: 4px;
  background-color: var(--very-light-pink);
  overflow: hidden;
}

.adoptionFill {
  height: 100%;
  border-radius: 4px;
  background-color: var(--tealish);
}

.adoptionValue {
  width: 55px;
  margin-left: 8px;
  font-size: 13px;
  color: var(--black);
}

.crashFree {
  width: 140px;
  font-size: 14px;
  color: var(--bb-grey);
}

.headerRow .crashFree {
  font-size: 12px;
  color: var(--black);
}

.issues {
  width: 90px;
  font-size: 14px;
  color: var(--black);
}

.headerRow .issues {
  font-size: 12px;
}

.issuesLink {
  color: var(--tealish);
  text-decoration: underline;
  cursor: pointer;
}

.empty {
  margin: auto;
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background-color: var(--fully-white);
}

.empty img {
  margin-bottom: 5px;
}

.empty div {
  font-size: 18px;
  font-weight: bold;
  color: var(--marine);
}

.empty div div:last-child {
  font-size: 16px;
  font-weight: normal;
  white-space: pre-wrap;
}
